<div class="game-organization-logo" [ngClass]="['game-organization-logo--theme-' + currentTheme]" #mainEl>
  <div class="game-organization-logo__wrapper">
    <span>{{name}}</span>
  </div>
</div>
